import { useLocation } from 'react-router';

/**
 * The record a "new" form starts from when it was opened with Duplicate (⋯ menu): passed in the
 * navigation state as `{ copy }`. Null on a plain "new"; the caller knows the record's type.
 */
export function useCopy(): unknown {
  const state = useLocation().state as { copy?: unknown } | null;
  return state?.copy ?? null;
}
